import { HttpClient } from '@angular/common/http';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { Blog } from 'src/app/models/common/BlogLoginResp';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private router: Router, private http: HttpClient) { }
GetAllBlog(user): Observable<any> {
    const body = user;
    return this.http.get(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Blog/all-blog`, JSON_HTTP_OPTIONS);
  }

  GetBlogByID(Blog): Observable<any> {
    return this.http.get(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Blog/${Blog.BlogID}`, JSON_HTTP_OPTIONS);
  }

  InsertBlog(blogData): Observable<any> {
    const body = blogData;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Blog/blog`, body, JSON_HTTP_OPTIONS);
  }

  UpdateBlog(blogData): Observable<any> {
    const body = blogData;
    return this.http.put(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Blog/blog`, body, JSON_HTTP_OPTIONS);
  }

  DeleteBlog(BlogID): Observable<any> {
    return this.http.delete(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Blog/${BlogID}`, JSON_HTTP_OPTIONS);
  }
}
